// extracted by mini-css-extract-plugin
module.exports = {"menuSection":"_2VDA2","sectionTitle":"_3_ko9"};